import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';

ReactDOM.render(
  // TODO: figure out a way to enable react strict mode
  // without triggering duplicate graphql queries
  // https://github.com/apollographql/react-apollo/issues/3906#issuecomment-636604835
  // <React.StrictMode>
    <App/>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
